import React, { useEffect, useState } from "react";
import {
  fetchTransactions,
  updateTransaction,
  deleteTransaction,
} from "../api.js";

export default function EditPage() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    name: "",
    comment: "",
    type: "out",
    amount: "",
    date: "",
  });

  useEffect(() => {
    fetchTransactions().then(setItems);
  }, []);

  function startEdit(item) {
    setEditingId(item._id);
    setForm({
      name: item.name,
      comment: item.comment,
      type: item.type,
      amount: item.amount,
      date: item.date ? item.date.slice(0, 10) : "",
    });
  }

  function cancelEdit() {
    setEditingId(null);
    setForm({ name: "", comment: "", type: "out", amount: "", date: "" });
  }

  async function saveEdit() {
    const updated = await updateTransaction(editingId, form);
    setItems((prev) =>
      prev.map((item) => (item._id === editingId ? updated : item))
    );
    cancelEdit(); // real-time UI update
  }

  async function remove(id) {
    await deleteTransaction(id);
    setItems((prev) => prev.filter((item) => item._id !== id));
  }

  return (
    <div>
      <h2>Edit Monthly Expenses</h2>

      {items.map((item) => {
        const isEditing = editingId === item._id;

        if (isEditing) {
          return (
            <div key={item._id}>
              <div>
                <label>Name:</label>
                <input
                  value={form.name}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, name: e.target.value }))
                  }
                />
              </div>

              <div>
                <label>Comment:</label>
                <input
                  value={form.comment}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, comment: e.target.value }))
                  }
                />
              </div>

              <div>
                <label>Type:</label>
                <select
                  value={form.type}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, type: e.target.value }))
                  }
                >
                  <option value="in">In</option>
                  <option value="out">Out</option>
                </select>
              </div>

              <div>
                <label>Amount:</label>
                <input
                  type="number"
                  step="0.01"
                  value={form.amount}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, amount: e.target.value }))
                  }
                />
              </div>

              <div>
                <label>Date:</label>
                <input
                  type="date"
                  value={form.date}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, date: e.target.value }))
                  }
                />
              </div>

              <button onClick={saveEdit}>Save</button>
              <button onClick={cancelEdit}>Cancel</button>
              <button onClick={() => remove(item._id)}>Delete</button>

              <hr />
            </div>
          );
        }

        return (
          <div key={item._id}>
            <p>Name: {item.name}</p>
            <p>Comment: {item.comment}</p>
            <p>Type: {item.type}</p>
            <p>Amount: {item.amount}</p>
            <p>Date: {new Date(item.date).toLocaleDateString()}</p>
            <button onClick={() => startEdit(item)}>Edit</button>
            <button onClick={() => remove(item._id)}>Delete</button>
            <hr />
          </div>
        );
      })}
    </div>
  );
}
